import styled from 'styled-components'

export const RouteButtonComponent = styled.div`
  @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
    width: 100%;
    padding: 0 15px;

    .with-border {
      margin: 0;
    }
  }

  .link-route {
    display: inline-flex;
    align-items: center;

    svg {
      width: 18px;
      height: 18px;
    }
  }
`
